import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, computed, ref , onBeforeMount} from 'vue';
import Cookies from "js-cookie";
import { useRoute } from 'vue-router';
import { OrganismsBar, OrganismsNavigation } from '@/components/organisms';
import { AtomPreloader } from '@/components/atoms';
import { MoleculeCookies } from '@/components/molecules';
import { Authentication } from '@/store';
import { IMenuItem } from './types';
import { routes } from './router';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const menus = computed(() => {
  let acesso: any[] = [];
  let mk = Authentication.getters.getUser.value.roles?.find((f) => f.name.toLowerCase() == 'mk');
  Authentication.getters.getUser.value.roles
    ?.filter((f) => f.name.toLowerCase() == 'mk')
    ?.map((f) => f.data)
    .map((f) => {
      acesso = [...acesso, ...f.functionalities];
    });

  //TODO: Aplicar reordenação dos menus para construção da barra lateral
  const rotas = routes
    .filter((f) => f.name != 'Login' && f.name != 'Mk')
    .map((f) => {
      return {
        name: f.meta ? f.meta[String(mk?.data.role).toLowerCase()] : f.name,
        path: f.path,
        icon: f?.meta?.icon,
        divider: f?.meta?.divider,
        group:
          f.path.includes('licenceFirstLicencing') ||
          f.path.includes('mostUsedManufacturerApplications') ||
          f.path.includes('licencesExpirationDateByCompany') ||
          f.path.includes('groupsLicenceUtilization') ||
          f.path.includes('collaboratorsLicenceUtilization') ||
          f.path.includes('collaboratorsWithMostLicencesObtained') ||
          f.path.includes('headquartersWithMostLicences') ||
          f.path.includes('applicationsWithMostLicences')
            ? 1
            : 0,
      } as IMenuItem;
    });
  return rotas.filter((f) => acesso?.find((x) => (x.path.includes('/') ? x.path : `/${x.path}`) == f.path));
});

const route = useRoute();
onMounted(() => {
  Authentication.actions.ActionCheckToken();
});

const title = computed(() => {
  let mk = Authentication.getters.getUser.value.roles?.find((f) => f.name.toLowerCase() == 'mk');
  return route.meta[String(mk?.data.role).toLowerCase()] ?? '';
});

onBeforeMount(() => {
  if (Cookies.get("acceptCookies")) {
      Authentication.actions.ActionSetshowCookies(false)
    }
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_main, null, {
          default: _withCtx(() => [
            (_unref(Authentication).getters.getStatusLoggedIn.value)
              ? (_openBlock(), _createBlock(_unref(OrganismsNavigation), {
                  key: 0,
                  menus: _unref(menus)
                }, null, 8, ["menus"]))
              : _createCommentVNode("", true),
            (_unref(Authentication).getters.getStatusLoggedIn.value)
              ? (_openBlock(), _createBlock(_unref(OrganismsBar), {
                  key: 1,
                  title: String(_unref(title))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass([[_unref(Authentication).getters.getStatusLoggedIn.value ? 'area-content' : ''], "h-100"])
            }, [
              (_openBlock(), _createBlock(_component_router_view, {
                key: _ctx.$route.fullPath
              }))
            ], 2)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(AtomPreloader))
  ], 64))
}
}

})